import { render, staticRenderFns } from "./AccessDenied.vue?vue&type=template&id=139bd54f&scoped=true&"
import script from "./AccessDenied.vue?vue&type=script&lang=js&"
export * from "./AccessDenied.vue?vue&type=script&lang=js&"
import style0 from "./AccessDenied.vue?vue&type=style&index=0&id=139bd54f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "139bd54f",
  null
  
)

export default component.exports